import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Globe, ShieldCheck, Lock, CreditCard, Star } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-dark text-white md:pt-20 pb-16 md:pb-24 px-4 overflow-hidden relative pt-[10px]" data-id="element-143">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-144">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-accent/5 rounded-full blur-[120px]" data-id="element-145"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center w-full" data-id="element-147">
          <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4 md:mb-8" data-id="element-148">
            <span className="text-xl" data-id="element-149">🔬</span> PROFEPACK
          </div>

          <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-sans pl-[0px] pr-[0px] mt-[-20px] mb-[-20px] leading-[0.95]" data-id="element-150">
            Todo tu año de Física y Química
            <br data-id="element-151" />
            <span className="text-brand-accent" data-id="element-152">resuelto.</span>
          </h1>
        </motion.div>

        <motion.div className="w-full max-w-[220px] sm:max-w-xs md:max-w-lg mx-auto relative mt-6 md:mt-12 mb-6 md:mb-12" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-153">
          {/* Glow effect behind image */}
          <div className="absolute inset-0 bg-brand-accent/20 blur-[60px] md:blur-[80px] rounded-full scale-75" data-id="element-154"></div>
          <img src="https://cdn.magicpatterns.com/uploads/xreJrC7QZ2pqEundwF9PmH/Sin-titulo-_420-x-420-px_.webp" alt="Megapack Física y Química Lista" className="w-full h-auto object-contain relative z-10 drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] mt-[-5px] mb-[-10px]" loading="eager" decoding="async" fetchPriority="high" width={420} height={420} data-id="element-155" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center w-full max-w-3xl" data-id="element-156">
          <h2 className="text-lg sm:text-xl md:text-3xl text-brand-accent font-heading font-bold md:mb-6 px-2 mb-[5px]" data-id="element-157">
            "Listo para usar. Sin buscar más."
          </h2>

          <p className="text-base md:text-xl text-white/70 md:mb-10 leading-relaxed px-2 mb-[10px]" data-id="element-158">
            El sistema que usan docentes de Física y Química de secundaria en
            Argentina para planificar{' '}
            <span className="text-white font-bold" data-id="element-159">
              todo el año en una tarde
            </span>
          </p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-6 md:mb-10" data-id="element-160">
            <div className="flex items-center gap-1.5 text-xs md:text-sm font-medium border border-brand-border bg-brand-card px-3 md:px-4 py-1.5 md:py-2 rounded-full text-white/80" data-id="element-161">
              <FileText size={14} className="text-brand-accent" data-id="element-162" /> 100% PDF
            </div>
            <div className="flex items-center gap-1.5 text-xs md:text-sm font-medium border border-brand-border bg-brand-card px-3 md:px-4 py-1.5 md:py-2 rounded-full text-white/80" data-id="element-163">
              <Zap size={14} className="text-brand-accent" data-id="element-164" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-1.5 text-xs md:text-sm font-medium border border-brand-border bg-brand-card px-3 md:px-4 py-1.5 md:py-2 rounded-full text-white/80" data-id="element-165">
              <Globe size={14} className="text-brand-accent" data-id="element-166" /> 🇦🇷 Currículo
              argentino
            </div>
          </div>

          <motion.button onClick={() => {
          const el = document.getElementById('pricing');
          if (el) {
            const y = el.getBoundingClientRect().top + window.pageYOffset + 100;
            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          }
        }} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-xl md:text-3xl py-5 md:py-6 px-10 md:px-14 rounded-2xl shadow-[0_0_30px_rgba(0,255,133,0.3)] transition-all flex items-center justify-center md:gap-3 mb-5 md:mb-8 mx-4 sm:mx-0 font-[Poppins,_sans-serif] pl-[0px] pr-[0px] ml-[50px] mr-[50px] gap-[0px]" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0px 0px 0px rgba(0,255,133,0)', '0px 0px 30px rgba(0,255,133,0.5)', '0px 0px 0px rgba(0,255,133,0)']
        }} transition={{
          boxShadow: {
            repeat: Infinity,
            duration: 2
          }
        }} data-id="element-167">
            → QUIERO MI PROFEPACK AHORA
          </motion.button>

          <div className="flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-2 text-xs md:text-sm text-white/50 font-medium" data-id="element-168">
            <div className="flex items-center gap-1.5" data-id="element-169">
              <ShieldCheck size={14} data-id="element-170" /> Garantía 7 días sin preguntas
            </div>
            <div className="flex items-center gap-1.5" data-id="element-171">
              <Lock size={14} data-id="element-172" /> Pago 100% seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <CreditCard size={14} data-id="element-174" /> Mercado Pago
            </div>
          </div>
        </motion.div>

        {/* Stats Bar */}
        <motion.div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-175">
          <div className="text-center" data-id="element-176">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-177">
              +1.500
            </div>
            <div className="text-xs md:text-sm text-white/60 font-medium uppercase tracking-wider" data-id="element-178">
              docentes confían
            </div>
          </div>
          <div className="text-center" data-id="element-179">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-180">
              12
            </div>
            <div className="text-xs md:text-sm text-white/60 font-medium uppercase tracking-wider" data-id="element-181">
              Volúmenes listos
            </div>
          </div>
          <div className="text-center" data-id="element-182">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1 flex items-center justify-center gap-1" data-id="element-183">
              4.9/5{' '}
              <Star size={16} className="md:w-6 md:h-6" fill="currentColor" data-id="element-184" />
            </div>
            <div className="text-xs md:text-sm text-white/60 font-medium uppercase tracking-wider" data-id="element-185">
              calificación
            </div>
          </div>
          <div className="text-center" data-id="element-186">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-187">
              🇦🇷
            </div>
            <div className="text-xs md:text-sm text-white/60 font-medium uppercase tracking-wider" data-id="element-188">
              Todo el país
            </div>
          </div>
        </motion.div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-189">
          {[{
          initials: 'MG',
          name: 'Marcela G.',
          loc: 'Córdoba | Secundaria',
          quote: 'Organicé todo el año de Física en una tarde'
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Rosario | Secundaria',
          quote: 'Mis clases de Química por fin tienen estructura real'
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Buenos Aires | Física y Química',
          quote: 'Nunca más llegué a clase sin saber qué hacer'
        }].map((test, i) => <motion.div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-190">
              <div className="flex items-center gap-3 mb-3" data-id="element-191">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" data-id="element-192">
                  {test.initials}
                </div>
                <div className="flex text-brand-accent" data-id="element-193">
                  {[...Array(5)].map((_, j) => <Star key={j} size={12} fill="currentColor" data-id="element-194" />)}
                </div>
              </div>
              <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-195">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-white/50 uppercase tracking-wider font-bold" data-id="element-196">
                — {test.name}, {test.loc}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}